













































import Vue, { PropType } from 'vue'
import UiSeriesInfo from '../UiSeriesInfo'
import UiSeriesItem from './UiSeriesItem'
import UiSeriesComparisonCart from './UiSeriesComparisonCart'
import UiSeriesCompareList from './UiSeriesCompareList'
import { SeriesList, I18n, ProductItem } from './UiSeriesList.types'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default Vue.extend({
  name: 'UiSeriesList',
  components: {
    UiSeriesInfo,
    UiSeriesItem,
    UiSeriesComparisonCart,
    UiSeriesCompareList
  },
  props: {
    seriesList: {
      type: Array as PropType<SeriesList[]>,
      required: true
    },
    comparisonPageUri: {
      type: String,
      default: '/'
    },
    i18n: {
      type: Object as PropType<I18n>,
      default: () => ({} as I18n)
    }
  },
  data () {
    return {
      selectedEans: [] as string[],
      showProductsList: false
    }
  },
  computed: {
    i18nVerified (): I18n {
      const defaultTranslations: I18n = {
        addToComparison: 'Add to comparison:',
        manageRobots: 'Manage robots',
        addButton: 'Add',
        removeButton: 'Remove',
        compareButton: 'Compare'
      }

      return Object.assign(defaultTranslations, this.i18n)
    },
    products (): ProductItem[] {
      const products = this.seriesList
        .map((series: SeriesList) => series.products)
        .reduce((flat, toFlat) => flat.concat(toFlat), [])
      return products
    },
    selectedProducts (): ProductItem[] {
      return this.selectedEans
        .map((ean: string): ProductItem => this.products
          .find((product: ProductItem): boolean => ean === product.content?.buyButtonEan) as ProductItem
        )
    },
    lockAdding (): boolean {
      return this.selectedEans.length >= 4
    },
    showCart (): boolean {
      return this.selectedEans.length > 0
    },
    comparisonUrl (): string {
      return `${this.comparisonPageUri}?products=${this.selectedEans.join(',')}`
    }
  },
  beforeDestroy () {
    clearAllBodyScrollLocks()
  },
  methods: {
    addProduct (ean: string): void {
      this.selectedEans.push(ean)
      const addedProduct = this.products.find((product: ProductItem): boolean => product.content?.ean === ean)
      if (addedProduct) {
        addedProduct.isSelected = true
      }
    },
    removeProduct (ean: string): void {
      this.selectedEans = this.selectedEans.filter((currentEan: string): boolean => currentEan !== ean)
      const removedProduct = this.products.find((product: ProductItem): boolean => product.content?.ean === ean)
      if (removedProduct) removedProduct.isSelected = false
    },
    toggleProductsList (): void {
      this.showProductsList = !this.showProductsList
    },
    openListHandler (): void {
      this.toggleProductsList()
      disableBodyScroll(this.$refs.products as HTMLElement)
    },
    closeListHandler (): void {
      this.toggleProductsList()
      enableBodyScroll(this.$refs.products as HTMLElement)
    }
  }
})
